import { Team } from "../../component/Speakers";

export const SpeakersContent = () => {
  return <Team />;
};
